// extracted by mini-css-extract-plugin
var _1 = "ProfileAISummaryWidget-moduleProfileAISummaryWidget__B5VA7 Widget-moduleWidget__bcnWB";
var _2 = "ProfileAISummaryWidget-modulecontentContainer__gFTdM";
export { _1 as "ProfileAISummaryWidget", _2 as "contentContainer" }
